module.exports = __webpack_public_path__ + "static/media/animal-dog2.6d227716.aac";